/** @format */
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';

import { MarketContext } from '@toucan/client/global/market';
import { UserContext } from '@toucan/client/global/user';

/**
 * A hook that will protect the route from client side navigation.
 * Will redirect the user to the login form if not logged in already
 */
export const useAuthRoute = () => {
    const { push } = useRouter();
    const { t } = useTranslation();
    const [showContent, setShowContent] = useState<boolean>(false);
    const { activeMarket } = useContext(MarketContext);
    const { isLoggedIn, isInitialised } = useContext(UserContext);

    const loginSlug = t('login', { ns: 'urls' });

    useEffect(() => {
        if (!isInitialised) {
            return;
        }

        if (!isLoggedIn) {
            push(`/${loginSlug}`, `/${activeMarket.slug}/${loginSlug}`);
            return;
        }

        setShowContent(true);
    }, [isInitialised, isLoggedIn]);

    return {
        showContent,
    };
};
